const cardInfo = (state = {}, action) => {
  switch(action.type){
    case 'ADD_CARD':
      return action.data;

    case 'CLEAR_CARD':
      return null;

    default:
      return state;
  }
}

export default cardInfo